import Cookies from 'js-cookie';
import * as Logger from '../../common/tools/logger';
import {
  BRAND_DOMAIN,
  COOKIE_IDENTIFIER_CONSENT_LEVEL
} from './config';

/**
 * Function to store the consent level into a cookie
 * @param {string} consentLevel
 */
const setConsentLevelCookie = (consentLevel: string): void => {
  try {
    Cookies.remove(COOKIE_IDENTIFIER_CONSENT_LEVEL);
    // eslint-disable-next-line no-empty
  } catch (ignore) {}
  Cookies.set(COOKIE_IDENTIFIER_CONSENT_LEVEL, consentLevel, {
    domain: BRAND_DOMAIN,
    expires: 365,
    secure: window.location.protocol === 'https:' ? true : false,
  });
}

/**
 * Sets the `consentLevel` cookie, based on the `fullConsent` permission feature from the TCF API
 */
export const setConsentLevel = (): void => {
  if (typeof window.__tcfapi !== 'function') {
    Logger.error(`Compat`, `setConsentLevel`, `TCF API not initialized, not able to write the 'consentLevel' cookie.`);
    return;
  }

  try {
    window.__tcfapi('getPermission', 2, (permission: boolean) => {
      setConsentLevelCookie(permission ? '3' : '1');
    }, 'fullConsent');
  } catch (error) {
    Logger.error(`TCF`, `setConsentLevel`, `Failed to set the 'consentLevel' cookie.`, error);
  }
}
